var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataset = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5H22.5C23.3284 1.5 24 2.17157 24 3V21C24 21.8284 23.3284 22.5 22.5 22.5H1.5C0.671573 22.5 0 21.8284 0 21V3C0 2.17157 0.671573 1.5 1.5 1.5ZM22.5 3H1.5V21H22.5V3ZM21 6H3V7.5H21V6ZM3 9H10.5H21V19.5H3V9ZM4.5 10.5H9V12H4.5V10.5ZM9 13.5H4.5V15H9V13.5ZM4.5 18V16.5H9V18H4.5ZM10.5 18H19.5V16.5H10.5V18ZM19.5 15H10.5V13.5H19.5V15ZM10.5 12H19.5V10.5H10.5V12Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dataset.5960db6dda828e0ab0be1778b4f3bb40.svg";